module.exports = __webpack_public_path__ + "img/1.dd40aa7a.png";